<template>
    <router-view :key="$route.path"></router-view>
</template>

<script>
export default {
    name: 'App',
}
</script>

<style>
#app {
    font-family: dm_sans_regular, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
}
</style>
